/**
 * ShopInformationList
 * --
 */
import { useState, useEffect } from 'react';
import { Content, TabMenu } from 'components';
import { Input } from 'antd';
import { handleSearchKeyword } from 'utils/SearchKeyword';
import { useGetCoupons } from '../hooks/CouponHooks';
/**----------------------------------------
 * [Component] 입점업체 목록: 사이드 컴포넌트
 * ----------------------------------------
 */
const CouponList = ({
  coupons = [],
  onChange,
  fetch = true,
  query,
  onLoaded,
  maxHeight,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const { data: MenuCouponList } = useGetCoupons(
    query ? query : { type: 'MENU' },
    {
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) {
          return [];
        }

        return data;
      },
      initialData: [],
      refetchOnMount: false,
      enabled: fetch,
    }
  );
  const { data: ProductCouponList } = useGetCoupons(
    query ? query : { type: 'PRODUCT' },
    {
      select: (res) => {
        const { status, data } = res;

        if (status !== 200) {
          return [];
        }

        return data;
      },
      initialData: [],
      refetchOnMount: false,
      enabled: coupons?.length ? false : true,
    }
  );

  // 선택된 업체의 키
  const [keyword, setKeyword] = useState('');
  // 선택된 업체의 키
  const [currentCoupon, setCurrentCoupon] = useState(null);
  const [couponsList, setCouponsList] = useState(null);

  // 업체목록
  // const [couponList, setUserList] = useState(coupons?.data);

  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */

  useEffect(() => {
    let newData;
    if (coupons?.length) {
      newData = coupons;
    } else {
      newData = [
        ...new Map(
          [...MenuCouponList, ...ProductCouponList].map((coupon) => [
            coupon.coupon_id,
            coupon,
          ])
        ).values(),
      ];
    }
    const filteredData = handleSearchKeyword(newData, keyword, 'coupon_name');

    setCouponsList(filteredData);
  }, [coupons, keyword, MenuCouponList, ProductCouponList]);

  useEffect(() => {
    onChange(currentCoupon);
  }, [currentCoupon]);

  useEffect(() => {
    onLoaded(couponsList);
  }, [couponsList]);

  useEffect(() => {
    onLoaded(couponsList);
  }, [keyword]);

  /* ===== RENDER ===== */
  return (
    <>
      <Content
        maxWidth={'100%'}
        minHeight={662}
        padding={0}
        className="boxShadow"
        backgroundColor="#fff"
      >
        {/* === === */}
        <Content
          maxWidth={'100%'}
          padding={10}
          style={{ borderBottom: '1px solid #EBEBEB' }}
        >
          <Input
            placeholder="쿠폰명을 입력해주세요"
            allowClear
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
          />
        </Content>

        {/* === === */}
        <Content
          maxWidth={'100%'}
          padding={5}
          className="custom-scroll"
          style={{
            height: '100%',
            ...(maxHeight && {
              maxHeight: typeof maxHeight === 'number' ? maxHeight : 800,
              overflowY: 'auto',
            }),
          }}
        >
          <TabMenu
            items={couponsList?.map((item) => ({
              ...item,
              key: item?.coupon_id,
              activeKey: item?.coupon_id,
              // title: item.shop_information_name,
              label: (
                <>
                  <p className="cursorOverOpacity">{item?.coupon_name}</p>
                </>
              ),
            }))}
            style={{
              maxHeight: '100%', // 컨테이너 크기 제한 유지
              overflowY: 'auto', // 내용이 넘치면 스크롤
            }}
            activeKey={'coupon_id'}
            collapseKey={'coupon_id'}
            onChange={({ key }) => setCurrentCoupon(key)}
          />
        </Content>
      </Content>
    </>
  );
};

CouponList.defaultProps = {
  defaultId: null,
  query: null,
  maxHeight: null,
  coupons: [],
  fetch: true,
  maxHeight: 611,
  onChange: () => {},
  onLoaded: () => {},
};
export default CouponList;
